(function () {
  'use strict';

  if (window.SusuProductMerchandising) return;

  var desktopMedia = window.matchMedia('(min-width: 768px)');

  function isUpsell(module) {
    return module && module.dataset.susuMerchandisingType === 'upsell';
  }

  function syncAccordion(module) {
    var toggle = module.querySelector('[data-susu-merchandising-toggle]');
    if (!toggle) return;

    toggle.setAttribute('aria-expanded', desktopMedia.matches || module.classList.contains('is-open') ? 'true' : 'false');

    if (desktopMedia.matches) {
      var slider = module.querySelector('[data-susu-slider]');
      if (slider) initSlider(slider);
    }
  }

  function initAccordion(module) {
    var toggle = module.querySelector('[data-susu-merchandising-toggle]');
    if (!toggle || toggle.dataset.susuReady === 'true') return;

    toggle.dataset.susuReady = 'true';
    toggle.addEventListener('click', function () {
      if (desktopMedia.matches) return;
      module.classList.toggle('is-open');
      syncAccordion(module);

      if (module.classList.contains('is-open')) {
        var slider = module.querySelector('[data-susu-slider]');
        if (slider) {
          if (isUpsell(module)) {
            initMobileUpsell(slider);
            return;
          }

          window.requestAnimationFrame(function () {
            initMobileComplementary(slider);
          });
        }
      }
    });

    syncAccordion(module);
  }

  function clearMobileUpsell(slider) {
    slider.classList.remove('susu-mobile-pager-ready');
    slider.querySelectorAll('.susu-upsell-slider__item').forEach(function (item) {
      item.classList.remove('is-mobile-visible');
      item.removeAttribute('aria-hidden');
    });

    var pagination = slider.querySelector('[data-susu-mobile-pagination]');
    if (pagination) pagination.hidden = true;
  }

  function destroySlider(slider) {
    if (!slider || !slider._susuSlider) return;

    if (typeof slider._susuSlider.destroy === 'function') slider._susuSlider.destroy();
    slider._susuSlider = null;
    slider.dataset.susuSliderReady = 'false';
    slider.dataset.susuSliderAttempts = '0';
    slider.classList.remove('slider-initialized', 'susu-slider-native');
  }

  function clearMobileComplementary(slider) {
    if (!slider) return;
    slider.classList.remove('susu-mobile-scroll-ready');
    slider.dataset.susuSliderReady = 'false';
  }

  function initMobileComplementary(slider) {
    if (!slider || desktopMedia.matches) return;
    destroySlider(slider);
    slider.classList.add('susu-mobile-scroll-ready');
    unveilImages(slider);
  }

  function initMobileUpsell(slider) {
    if (!slider || desktopMedia.matches) return;

    var module = slider.closest('[data-susu-product-merchandising]');
    var items = Array.prototype.slice.call(slider.querySelectorAll('.susu-upsell-slider__item'));
    var pagination = slider.querySelector('[data-susu-mobile-pagination]');
    var count = slider.querySelector('[data-susu-mobile-count]');
    var previous = slider.querySelector('[data-susu-mobile-prev]');
    var next = slider.querySelector('[data-susu-mobile-next]');
    var pageSize = Math.max(3, Math.min(4, Number(module && module.dataset.susuMobilePageSize) || 3));
    var pageCount = Math.max(1, Math.ceil(items.length / pageSize));

    if (!items.length) return;

    destroySlider(slider);
    slider.classList.add('susu-mobile-pager-ready');

    function showPage(requestedPage) {
      var page = Math.max(0, Math.min(pageCount - 1, requestedPage));
      var start = page * pageSize;
      var end = Math.min(items.length, start + pageSize);

      slider.dataset.susuMobilePage = String(page);
      items.forEach(function (item, index) {
        var visible = index >= start && index < end;
        item.classList.toggle('is-mobile-visible', visible);
        item.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) unveilImages(item);
      });

      if (count) count.textContent = String(start + 1) + '-' + String(end) + ' of ' + String(items.length);
      if (previous) previous.disabled = page === 0;
      if (next) next.disabled = page === pageCount - 1;
    }

    if (pagination) pagination.hidden = pageCount <= 1;

    if (slider.dataset.susuMobilePagerReady !== 'true') {
      slider.dataset.susuMobilePagerReady = 'true';
      if (previous) {
        previous.addEventListener('click', function () {
          showPage(Number(slider.dataset.susuMobilePage || 0) - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          showPage(Number(slider.dataset.susuMobilePage || 0) + 1);
        });
      }
    }

    showPage(Number(slider.dataset.susuMobilePage || 0));
  }

  function unveilImages(scope) {
    if (!window.lazySizes || !window.lazySizes.loader) return;
    scope.querySelectorAll('.lazyload').forEach(function (image) {
      window.lazySizes.loader.unveil(image);
    });
  }

  function initCompactCards(scope) {
    scope.querySelectorAll('[data-susu-card-url]').forEach(function (card) {
      if (card.dataset.susuCardReady === 'true') return;
      card.dataset.susuCardReady = 'true';

      card.addEventListener('click', function (event) {
        if (event.target.closest('a, button, input, select, textarea')) return;
        window.location.href = card.dataset.susuCardUrl;
      });

      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' || event.target.closest('a, button')) return;
        window.location.href = card.dataset.susuCardUrl;
      });

      if (window.ProductCard && typeof window.ProductCard.initEvent === 'function') {
        window.ProductCard.initEvent(card);
      }
    });
  }

  function initNativeControls(sliderContainer) {
    if (sliderContainer.dataset.susuNativeControlsReady === 'true') return;

    var track = sliderContainer.querySelector('.slider-list');
    var scrollTarget = sliderContainer.querySelector('.susu-upsell-slider__viewport') || track;
    var previous = sliderContainer.querySelector('.js-prev-button');
    var next = sliderContainer.querySelector('.js-next-button');
    if (!track || !scrollTarget) return;

    sliderContainer.dataset.susuNativeControlsReady = 'true';
    sliderContainer.classList.add('susu-slider-native');

    function updateControls() {
      if (!previous || !next) return;

      var maxScroll = Math.max(0, scrollTarget.scrollWidth - scrollTarget.clientWidth - 2);
      var controls = previous.parentElement;
      if (controls) controls.hidden = maxScroll <= 2;
      previous.classList.toggle('is-disabled', scrollTarget.scrollLeft <= 2);
      next.classList.toggle('is-disabled', scrollTarget.scrollLeft >= maxScroll);
      previous.setAttribute('aria-disabled', scrollTarget.scrollLeft <= 2 ? 'true' : 'false');
      next.setAttribute('aria-disabled', scrollTarget.scrollLeft >= maxScroll ? 'true' : 'false');
    }

    if (!previous || !next) {
      unveilImages(sliderContainer);
      return;
    }

    [previous, next].forEach(function (control) {
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
    });

    function scroll(direction) {
      scrollTarget.scrollBy({ left: direction * scrollTarget.clientWidth * 0.72, behavior: 'smooth' });
    }

    previous.addEventListener('click', function () {
      scroll(-1);
    });
    next.addEventListener('click', function () {
      scroll(1);
    });

    previous.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        scroll(-1);
      }
    });
    next.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        scroll(1);
      }
    });

    scrollTarget.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  function syncTnsControls(sliderContainer) {
    var slider = sliderContainer && sliderContainer._susuSlider;
    var controls = sliderContainer && sliderContainer.querySelector('.js-slider-controls');
    if (!slider || !controls || typeof slider.getInfo !== 'function') return;

    var info = slider.getInfo();
    controls.hidden = Number(info.slideCount || 0) <= Number(info.items || 1);
  }

  function initSlider(sliderContainer) {
    if (!sliderContainer || sliderContainer.dataset.susuSliderReady === 'true') return;

    var module = sliderContainer.closest('[data-susu-product-merchandising]');
    if (!desktopMedia.matches) {
      if (isUpsell(module)) {
        initMobileUpsell(sliderContainer);
      } else {
        initMobileComplementary(sliderContainer);
      }
      return;
    }

    if (isUpsell(module)) {
      clearMobileUpsell(sliderContainer);
    } else {
      clearMobileComplementary(sliderContainer);
    }

    var configElement = sliderContainer.querySelector('[data-tns-config]');
    if (!configElement) return;

    var attempts = Number(sliderContainer.dataset.susuSliderAttempts || 0);
    if (typeof window.tns !== 'function' && attempts < 40) {
      sliderContainer.dataset.susuSliderAttempts = String(attempts + 1);
      window.setTimeout(function () {
        initSlider(sliderContainer);
      }, 50);
      return;
    }

    sliderContainer.dataset.susuSliderReady = 'true';

    if (typeof window.tns !== 'function') {
      initNativeControls(sliderContainer);
      unveilImages(sliderContainer);
      return;
    }

    try {
      var config = JSON.parse(configElement.textContent);
      config.onInit = function () {
        sliderContainer.classList.add('slider-initialized');
        unveilImages(sliderContainer);
      };
      sliderContainer._susuSlider = window.tns(config);
      sliderContainer._susuSlider.events.on('indexChanged', function () {
        unveilImages(sliderContainer);
        syncTnsControls(sliderContainer);
      });
      sliderContainer._susuSlider.events.on('newBreakpointEnd', function () {
        syncTnsControls(sliderContainer);
      });
      window.requestAnimationFrame(function () {
        syncTnsControls(sliderContainer);
      });
    } catch (error) {
      console.warn('Product merchandising slider could not initialize.', error);
      initNativeControls(sliderContainer);
      unveilImages(sliderContainer);
    }
  }

  function refreshReviewBadges(scope) {
    if (window.SPR) {
      if (typeof window.SPR.initDomEls === 'function') window.SPR.initDomEls();
      if (typeof window.SPR.loadBadges === 'function') window.SPR.loadBadges();
      if (typeof window.SPR.loadProducts === 'function') window.SPR.loadProducts();
    }

    if (window.jdgm && typeof window.jdgm.initWidgets === 'function') {
      window.jdgm.initWidgets(scope);
    }

    if (window.Currencies && typeof window.Currencies.registerObserve === 'function') {
      scope.querySelectorAll('.js-money').forEach(function (money) {
        window.Currencies.registerObserve(money);
      });
    }
  }

  function initModules(scope) {
    scope.querySelectorAll('[data-susu-product-merchandising]').forEach(function (module) {
      initAccordion(module);
      var slider = module.querySelector('[data-susu-slider]');
      if (!slider) return;

      if (desktopMedia.matches) {
        initSlider(slider);
      } else if (module.classList.contains('is-open')) {
        if (isUpsell(module)) initMobileUpsell(slider);
        else initMobileComplementary(slider);
      }
    });

    initCompactCards(scope);
  }

  function fetchComplementary(root) {
    if (root.dataset.susuRecommendationsState) return;
    root.dataset.susuRecommendationsState = 'loading';

    fetch(root.dataset.recommendationsUrl, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var source = parsed.getElementById(root.id);

        if (!source || !source.querySelector('[data-susu-product-merchandising]')) {
          root.remove();
          return;
        }

        root.innerHTML = source.innerHTML;
        root.hidden = false;
        root.dataset.susuRecommendationsState = 'loaded';
        initModules(root);
        unveilImages(root);
        refreshReviewBadges(root);
      })
      .catch(function (error) {
        console.warn('Complete Your Repair products could not be loaded.', error);
        root.remove();
      });
  }

  function queueComplementary(root) {
    if (!root.dataset.recommendationsUrl || root.dataset.susuRecommendationsState) return;
    fetchComplementary(root);
  }

  function init(scope) {
    var context = scope || document;
    initModules(context);
    context.querySelectorAll('[data-susu-complementary-root]').forEach(queueComplementary);
  }

  function syncAllAccordions() {
    document.querySelectorAll('[data-susu-product-merchandising]').forEach(function (module) {
      var slider = module.querySelector('[data-susu-slider]');

      if (slider && isUpsell(module)) {
        if (desktopMedia.matches) {
          clearMobileUpsell(slider);
        } else {
          destroySlider(slider);
          if (module.classList.contains('is-open')) initMobileUpsell(slider);
        }
      } else if (slider) {
        if (desktopMedia.matches) {
          clearMobileComplementary(slider);
        } else {
          destroySlider(slider);
          if (module.classList.contains('is-open')) initMobileComplementary(slider);
        }
      }

      syncAccordion(module);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  if (typeof desktopMedia.addEventListener === 'function') {
    desktopMedia.addEventListener('change', syncAllAccordions);
  } else if (typeof desktopMedia.addListener === 'function') {
    desktopMedia.addListener(syncAllAccordions);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = document.getElementById('shopify-section-' + event.detail.sectionId) || document;
    init(section);
  });

  window.SusuProductMerchandising = { init: init };
})();
